// İSG uzmanı portalı — Firma detay: Şube (Branch) yönetimi (api-contract §9.5).
// Firma başlığı `GET /admin/companies/{uuid}`'den; her şube → sahalar (§9.6).

import { type BranchAdminDto, Breadcrumb, Button, PageHeader, adminApi } from '@isgportal/shared';
import { useQuery } from '@tanstack/react-query';
import { Building, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { EntityCrudTable } from '../../components/admin/EntityCrudTable';
import { adminKeys } from '../../lib/adminKeys';

export function CompanyDetailPage() {
  const { t } = useTranslation();
  const { companyUuid = '' } = useParams();

  const companyQuery = useQuery({
    queryKey: adminKeys.company(companyUuid),
    queryFn: () => adminApi.getCompany(companyUuid),
    enabled: companyUuid.length > 0,
  });

  const companyName = companyQuery.data?.name ?? '…';

  return (
    <div className="flex flex-col gap-6">
      <Breadcrumb
        items={[
          { label: t('admin.nav'), href: '/admin' },
          { label: t('admin.tab.companies'), href: '/admin/companies' },
          { label: companyName },
        ]}
      />
      <PageHeader title={companyName} id={t('admin.branches.title')} />

      {/* `EntityCrudTable` kendi Tile'ını (`Card` + `carbon:p-0`) taşır — burada İKİNCİ bir
          `Card` sarmalayıcı ÇİFT dolgu/kenarlık üretirdi (S33 Slice 6). */}
      <EntityCrudTable<BranchAdminDto>
        queryKeyBase={adminKeys.branches(companyUuid)}
        queryFn={(params) => adminApi.listBranches(companyUuid, params)}
        createSubmit={(values) => adminApi.createBranch(companyUuid, values)}
        updateSubmit={(branch, values) => adminApi.updateBranch(companyUuid, branch.uuid, values)}
        labels={{
          icon: Building,
          caption: t('admin.branches.title'),
          colName: t('admin.branches.col.name'),
          colCode: t('admin.branches.col.code'),
          newLabel: t('admin.branches.new'),
          createTitle: t('admin.branches.create.title'),
          editTitle: t('admin.branches.edit.title'),
          fieldName: t('admin.branches.field.name'),
          fieldCode: t('admin.branches.field.code'),
          searchPlaceholder: t('admin.branches.searchPlaceholder'),
          createdMessage: t('admin.branches.created'),
          updatedMessage: t('admin.branches.updated'),
          count: (count) => t('admin.branches.count', { count }),
        }}
        renderRowAction={(branch) => (
          <Button asChild variant="ghost" size="sm">
            <Link
              to={`/admin/companies/${companyUuid}/branches/${branch.uuid}`}
              state={{ branchName: branch.name, companyName }}
            >
              <MapPin className="h-4 w-4" aria-hidden="true" />
              {t('admin.branches.action.sites')}
            </Link>
          </Button>
        )}
      />
    </div>
  );
}
